var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgCloud2 = function SvgCloud2(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#cloud2_svg__a)",
    stroke: "#1A1E2C",
    strokeWidth: 0.75,
    strokeLinecap: "round"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.5 18C3.466 18 1 15.478 1 12.375c0-2.897 2.145-5.287 4.904-5.588C7.05 4.537 9.351 3 12 3c3.337 0 6.114 2.428 6.738 5.662 2.383.17 4.262 2.063 4.262 4.65C23 15.9 20.947 18 18.417 18"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.333 11.5 12 7.75l3.667 3.75M12 8v11"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "cloud2_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h24v24H0z"
  })))));
};
export default SvgCloud2;